<template>

  <div class="product-add pb50">
   <!--添加拍卖-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加拍卖</div>
      <el-form-item label="名称" prop="auction_name"><el-input v-model="form.auction_name"  placeholder="请输入名称" class="max-w460"></el-input></el-form-item>
      <el-form-item label="类型" prop="auction_type"><el-input v-model="form.auction_type" type="number" placeholder="请输入类型" class="max-w460"></el-input>
        <div class="tips">类型：1.生日纪忆酒，2.大坛封藏酒，3.大师纪念酒，4.明星纪念酒</div>
      </el-form-item>
<!--      <el-form-item label="文章分类">-->
<!--        <el-select v-model="form.category_id" placeholder="请选择">-->
<!--          <el-option v-for="(item, index) in catgory" :key="index" :label="item.name" :value="item.category_id"></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item label="图片">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img :src="path" class="mt10" width="120px;" v-if="isImg" :isImg="isImg" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="编码" prop="auction_number"><el-input v-model="form.auction_number" placeholder="请输入编码" class="max-w460"></el-input></el-form-item>


      <el-form-item label="拍卖价" prop="auction_price"><el-input type="number" v-model="form.auction_price" placeholder="请输入拍卖价格" class="max-w460"></el-input></el-form-item>
      <el-form-item label="年份" prop="auction_year"><el-input type="number" v-model="form.auction_year" placeholder="请输入年份" class="max-w460"></el-input></el-form-item>


      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import AuctionApi from '@/api/auction.js';
import Upload from '@/components/file/Upload';

export default {
  components: {
    Upload: Upload
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      path: '',
      /*form表单数据*/
      form: {
        auction_name: '',
        auction_type: '',
        auction_number: '',
        auction_price: '',
        auction_year: '',
        image_id: '',
      },

      loading: false,
      /*验证规则*/
      rules: {
        auction_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        auction_type: [{ required: true, message: '请输入类型', trigger: 'blur' }],
        auction_number: [{ required: true, message: '请输入编码', trigger: 'blur' }],
        auction_price: [{ required: true, message: '请输入拍卖价', trigger: 'blur' }],
        auction_year: [{ required: true, message: '请输入年份', trigger: 'blur' }],
      }
    };
  },
  created() {
    /*获取列表*/
    this.getCategoryList();
  },
  methods: {
  /*上传*/
    openUpload() {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.path = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*获取类别*/
   /* getCategoryList() {
      let self = this;
      let Params = {};

      ArticleApi.toAddArticle(Params, true)
        .then(res => {
          self.catgory = res.data.catgory;
          if(self.catgory.length > 0){
            self.form.category_id = self.catgory[0].category_id;
          }
        })
        .catch(error => {

        });
    },*/

    /*添加拍卖*/
    onSubmit() {
      let self = this;
      let form = self.form;
      //self.form.article_content = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AuctionApi.addAuction(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，添加成功',
                type: 'success'
              });
              self.$router.push('/plus/auction/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/auction/index'
      });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/auction/auction/add.vue